import { IMAGE_CONSTANT } from '../../constants/app';
import { getPromptLink } from '../../utils/helpers';
import {
  prizeWinner,
  rollModelKit,
  jenHealth,
  optimalBodyTherapyKit,
  optimalBodyTherapyKitWeb,
  jenHealthWebp,
} from './images';

export const mobilityFoundationsTestimonials = [
  {
    name: 'Joslin',
    testimonial:
      'Jen this program is such a lifesaver for me. I suffer from chronic back/hip/knee pain and after 5 MRIs, docs found nothing, and two years of PT made it worse! just want to say a huge thank you for the work you do and how accessible it is. I do this program religiously- thank you for getting me through some tough times. Much love to you and your family :white_heart:',
  },
  {
    name: 'Lori',
    testimonial:
      'I love Jen’s Mobility program, especially the ability to focus on specific body parts. Jen is always so informative and really helps demonstrate the movements and the rationale behind them!',
  },
  {
    name: 'Sara',
    testimonial:
      'In my quest to feel better in my body I have committed 4 weeks to focusing on mobility with @docjenfit and let me tell you, day 2 and I already feel the benefits.',
  },
  {
    name: 'Marlene',
    testimonial:
      'I am really enjoying the program so far. In less than a week I can really feel a difference in my most restricted areas (hips, chest, shoulders) I am recovering from a shoulder injury so this is great! I look forward to continuing.',
  },
  {
    name: 'Shalini',
    testimonial:
      'I started Jen’s mobility program in March and haven’t looked back. I have finally got my bod back and I am so grateful to this amazing sweet person. I used to hate exercising and now I look forward to each day. I love how Jen exudes peace and calm and manages to make me push myself a bit with gentle encouragement.',
  },
];

export const mobilityFoundationsFAQs = [
  {
    title: 'How do I log in to find my course?',
    description: [
      `Bookmark our site: <a href="https://jen.health">https://jen.health</a>. Make sure to always log in with the same method that you signed up with. You will find your course in the “Courses” tab once logged in. Email us at  <a data-rel="external" href="${getPromptLink(
        'jen@jen.health',
      )}">jen@jen.health</a> if you have any difficulty.`,
    ],
  },
  {
    title: 'How long do I have access to this course?',
    description: [
      'Good news! You have lifetime access! Of course, it is most beneficial to work through the 30 days consistently to see the most benefit, but you can certainly move at your own pace and revisit videos that are most needed.',
    ],
  },
  // {
  //   title: 'How do the prizes work and how can I win?',
  //   description: [
  //     'Anyone has a chance to win just for signing up prior to the start date (November 5th)! Those who choose to share their journey at least 3x/week (12 total posts) will have the opportunity to win some of our larger prizes! More information on how this works is located in your Welcome Ebook within your course.',
  //   ],
  // },
  {
    title: 'Can I ask personal questions to get more support?',
    description: [
      `Yes! The best way to get your questions answered would be to show up on our weekly lives that will be held with Dr. Jen Fraboni, Doctor of Physical Therapy every Sunday throughout the month of November! Along with education, she will be taking time to answer personal questions. Though we are not your personal doctor of physical therapy and therefore cannot assess or diagnose, we are available through email support <a data-rel="external" href="${getPromptLink(
        'jen@jen.health',
      )}">(jen@jen.health)</a> to help further guide what we recommend within the course.`,
    ],
  },
  {
    title: 'How long is each day?',
    description: [
      'Each day takes no longer than 3-8 minutes! We want this daily mobility plan to be attainable, educational and something you can continue for long term change!',
    ],
  },
  {
    title: 'Is there a way to track my progress?',
    description: [
      'Yes! Our platform automatically keeps track of what day you left off so when you click back into the course, it will pick up right where you left off! We will also provide a quick questionnaire prior to starting, self-assessment exercises before and after the course, and a workbook to note your findings.',
    ],
  },
  {
    title: 'What if I miss a day or week?',
    description: [
      'Not a problem! We understand that “life happens.” The course will automatically keep track of your progress so you can pick up right where you left off. Feel free to double up a day or just continue on one video at a time!',
    ],
  },
  {
    title: 'Can I use this alongside other programs or workouts I’m doing?',
    description: [
      'Yes! I want to encourage you to keep doing exercise or other programs you enjoy, while adding in this new mobility and education alongside your movement.',
    ],
  },
  {
    title: 'What equipment do I need for this course?',
    description: [
      'A mat, small towels, wall, bench/chair and small pillow are ideal! I will show other tools like a yoga block, Coregeous Ball, TuneUp Fitness Therapy Balls, Therapy Bands and dumbbells (all linked in the Welcome Ebook within your course) but these are all optional, not required.',
    ],
  },
  {
    title: 'Can I do this course while I’m pregnant?',
    description: [
      'Yes! Exercises on your stomach can be modified. Reach out to jen@jen.health if you need help with modifications along the way.',
    ],
  },
  {
    title: 'What if I’m already hypermobile, is this okay to do?',
    description: [
      'Yes! Mobility is all about learning how to strengthen and better control the full range of motion provided within the joint. We will be learning how to reduce muscle guarding and tension often built up due to hypermobility and then how to properly progress with strength to better control the range available.',
    ],
  },
  {
    title: 'What if I currently have an injury, is this okay to do?',
    description: [
      'Without knowing your history or injury, we cannot say for sure. We always recommend consulting with a local physical therapist or your physician prior to doing a new exercise program. Our goal is to only focus on building upon your baseline mobility and should not exacerbate symptoms or pain.',
    ],
  },
  {
    title:
      'What if I’m not injured but I have consistent or recurrent pain, is this okay to do?',
    description: [
      'Yes! I would highly recommend doing this program to understand where you may be restricted along the joints within your body and what approach would be best for your individual body. Mobility lays the foundation from which we move. Joint restrictions can often cause muscle compensations when we move. I recommend starting with improving your mobility to start reducing pain.',
    ],
  },
  {
    title:
      'I’ve done the Full Body Mobility Plan in Jen Health. How is this different?',
    description: [
      'That’s so great! One of our best plans! This course will take you through more specific assessments to understand where you’re most restricted and as we move through each week, you will learn different approaches of mobility to better specify what your body needs. Furthermore, we’ll have weekly lives to understand the science behind each week and help identify what focus would be best for your body. Furthermore, this is a challenge! If you join us for the month of November and post about your experience, you’ll be joining an amazing community for better support, motivation and accountability!',
    ],
  },
  {
    title: 'Can I get a refund if I’m not happy with the course?',
    description: [
      `We provide 100% refunds within the first 7 days after purchase. Keep in mind, you have 28 individual mobility videos that are fully video instructed and will progressively challenge mobility in new ways as you go through the course. Additionally, you will have 9 self-assessments to use and reuse as needed. We’d hate for you to miss out on the loads of education but want you to feel satisfied and supported along the way. Reach out to <a data-rel="external" href="${getPromptLink(
        'jen@jen.health',
      )}">jen@jen.health</a> for support.`,
    ],
  },
];

export const mobilityFoundationsWinningPrizes = [
  {
    title: 'Anyone has an opportunity to win just for signing up:',
    items: [
      {
        title: 'IntelliRoll',
        priceDisc: '($39.99 Value)',
        image: IMAGE_CONSTANT.foamRollerIcon,
      },
      {
        title: 'Roll Model Starter Kit from TuneUp Fitness',
        priceDisc: '($59.95 Value)',
        image: rollModelKit,
      },
    ],
  },
  {
    title: 'Participants who get involved with the community',
    items: [
      {
        title: 'Cash Prize Winner',
        priceDisc: 'of $500',
        image: prizeWinner,
      },
      {
        title: 'Free 1 Year of Jen Health (3 Winners)',
        priceDisc: '($300 Value)',
        image: jenHealth,
        imageWebP: jenHealthWebp,
      },
      {
        title: 'The Optimal Body Therapy Kit',
        priceDisc: '($59.95 Value)',
        image: optimalBodyTherapyKit,
        imageWebP: optimalBodyTherapyKitWeb,
      },
    ],
  },
];
